export const fetch_user_list = async (
    token,
) => {

    console.log('feching users', token)
    let user_list = {
        records: []
    };

    const response = await fetch(
        //"https://staging.api.control.vollume.com/admin/user/list",
        "http://localhost:1337/admin/user/list",
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    );
    user_list = await response.json();
    return user_list;
}

export const fetch_workspace_billing_info = async (
    workspace_id,
    token,
) => {
    console.log(workspace_id, token)
    var workspace_billing_info_url = new URL(
        `${process.env.API_ROOT}/workspace/${workspace_id}/subscription/info`
    );

    const workspace_billing_info_response = await fetch(
        workspace_billing_info_url,
        {
            headers: {
                Authorization: "Bearer " + token,
                "control-workspace": workspace_id,
            },
        }
    );

    if (workspace_billing_info_response.status == 401) {
        throw new Error("unauthorized");
    }

    var workspace_billing_info_json =
        await workspace_billing_info_response.json();

    console.log(workspace_billing_info_json);

    return workspace_billing_info_json;
};

export const fetch_workspace_member_list = async (
    workspace_id,
    token,
) => {
    var workspace_list_url = new URL(
        `${process.env.API_ROOT}/workspace/member/list`
    );

    const workspace_member_list_response = await fetch(workspace_list_url, {
        headers: {
            Authorization: "Bearer " + token,
            "control-workspace": workspace_id,
        },
    });

    var workspace_member_list_json =
        await workspace_member_list_response.json();

    console.log(workspace_member_list_json.records)

    return workspace_member_list_json.records;
};

export const fetch_device_login_list = async (
    device_name,
    token,
) => {
    var device_login_list_url = new URL(
        `${process.env.API_ROOT}/user/info/login/list?device_name=${device_name}`
    );

    const device_login_list_response = await fetch(device_login_list_url, {
        headers: {
            Authorization: "Bearer " + token,
        },
    });

    var device_login_list_json =
        await device_login_list_response.json();

    console.log(device_login_list_json.records)

    return device_login_list_json.records;
};

export const fetch_workspace_list = async (
    token,
) => {
    var workspace_list_url = new URL(
        `${process.env.API_ROOT}/workspace/v2/list`,
    );

    const workspace_list_response = await fetch(workspace_list_url, {
        headers: {
            Authorization: "Bearer " + token,
        },
    });

    let local_workspace_list = await workspace_list_response.json();

    return local_workspace_list.records;
}

export const handle_token_exchange = async (url_params_access_token) => {
    const login_response = await fetch(
        `${process.env.API_ROOT}/token/exchange/jwt`,
        {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ access_token: url_params_access_token }),
        }
    );

    const response = await login_response.json();

    console.log(response);

    if (response.code) {
        error_message = response.message;
        return;
    }

    console.log("handle_token_exchange_resp: ", response)
    return {
        token: response.token,
        user: response.user,
    };
};

export const fetch_workspace_sso_config = async (
    workspace_id,
    token,
) => {
    console.log(workspace_id, token)
    var workspace_sso_config_url = new URL(
        `${process.env.API_ROOT}/sso/workspace/config`
    );

    const workspace_sso_config_response = await fetch(
        workspace_sso_config_url,
        {
            headers: {
                Authorization: "Bearer " + token,
                "control-workspace": workspace_id,
            },
        }
    );

    var workspace_sso_config_json =
        await workspace_sso_config_response.json();

    console.log(workspace_sso_config_json);

    return workspace_sso_config_json;
};